﻿/*!
    *
    * Wijmo Library 5.20251.34
    * https://developer.mescius.com/wijmo
    *
    * Copyright(c) MESCIUS inc. All rights reserved.
    *
    * Licensed under the End-User License Agreement For MESCIUS Wijmo Software.
    * us.sales@mescius.com
    * https://developer.mescius.com/wijmo/licensing
    *
    */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { VueApi, WjComponentBehavior } from '@mescius/wijmo.vue2.base';
import * as wjcChartInteraction from '@mescius/wijmo.chart.interaction';
var WjFlexChartRangeSelectorBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartRangeSelectorBehavior, _super);
    function WjFlexChartRangeSelectorBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartRangeSelectorBehavior.tag = 'wj-flex-chart-range-selector';
    WjFlexChartRangeSelectorBehavior.parentInCtor = true;
    WjFlexChartRangeSelectorBehavior.props = [
        'isVisible',
        'min',
        'max',
        'orientation',
        'seamless',
        'minScale',
        'maxScale'
    ];
    WjFlexChartRangeSelectorBehavior.events = [
        'initialized',
        'rangeChanged'
    ];
    WjFlexChartRangeSelectorBehavior.classCtor = function () { return wjcChartInteraction.RangeSelector; };
    return WjFlexChartRangeSelectorBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.interaction.RangeSelector} class.
 *
 * The <b>wj-flex-chart-range-selector</b> component should be contained in
 * one of the following components:
 * {@link wijmo.vue2.chart.WjFlexChart}
 *  or {@link wijmo.vue2.chart.finance.WjFinancialChart}.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.interaction.RangeSelector} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartRangeSelector = WjFlexChartRangeSelectorBehavior.register();
function registerV3WjFlexChartRangeSelector(app) {
    app.component(WjFlexChartRangeSelectorBehavior.tag, WjFlexChartRangeSelector);
}
var WjFlexChartGesturesBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartGesturesBehavior, _super);
    function WjFlexChartGesturesBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartGesturesBehavior.tag = 'wj-flex-chart-gestures';
    WjFlexChartGesturesBehavior.parentInCtor = true;
    WjFlexChartGesturesBehavior.props = [
        'mouseAction',
        'interactiveAxes',
        'enable',
        'scaleX',
        'scaleY',
        'posX',
        'posY'
    ];
    WjFlexChartGesturesBehavior.events = [
        'initialized'
    ];
    WjFlexChartGesturesBehavior.classCtor = function () { return wjcChartInteraction.ChartGestures; };
    return WjFlexChartGesturesBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.interaction.ChartGestures} class.
 *
 * The <b>wj-flex-chart-gestures</b> component should be contained in
 * one of the following components:
 * {@link wijmo.vue2.chart.WjFlexChart}
 *  or {@link wijmo.vue2.chart.finance.WjFinancialChart}.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.interaction.ChartGestures} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartGestures = WjFlexChartGesturesBehavior.register();
function registerV3WjFlexChartGestures(app) {
    app.component(WjFlexChartGesturesBehavior.tag, WjFlexChartGestures);
}
export function registerChartInteraction(app) {
    if (VueApi.isV3Plus) {
        registerV3WjFlexChartRangeSelector(app);
        registerV3WjFlexChartGestures(app);
    }
}
